// extracted by mini-css-extract-plugin
export default {"likeContainer":"ReviewLikes_likeContainer__i2OPS","likeButton":"ReviewLikes_likeButton__4mioh"};